import React, { useEffect, useMemo } from 'react'
import { InstallationsContextProps } from '../types'
import useInstallation from '../hooks/use-installation'
import { InstallationsContext } from './installations-context'
import { useDispatch } from 'react-redux'
import { setActiveStorage } from 'src/State/Storage/StorageActions'
import { isEmpty } from 'lodash'

interface Props {
  children?: React.ReactNode
}

/**
 * Provides installation context
 */
const InstallationsProvider: React.VFC<Props> = ({ children }) => {
  const { installations, installationCount, installationsLoading, refreshInstallations } = useInstallation()
  const dispatch = useDispatch()

  useEffect(() => {
    if (installationCount === 1 && !isEmpty(installations)) {
      dispatch(setActiveStorage(installations[0].emsMasterDeviceId))
    }
  }, [installations, installationCount]) //eslint-disable-line

  const value: InstallationsContextProps = useMemo(() => {
    return {
      installationCount,
      installations,
      installationsLoading,
      refreshInstallations,
    }
  }, [installationCount, installations, installationsLoading, refreshInstallations])

  return <InstallationsContext.Provider value={value}>{children}</InstallationsContext.Provider>
}

export default InstallationsProvider
